export default __webpack_public_path__ + "static/media/img2_1.01b46b69.jpg";